import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

import DrawerBody from './DrawerBody';
import DrawerContent from './DrawerContent';
import DrawerFooter from './DrawerFooter';
import DrawerHeader from './DrawerHeader';
import DrawerPanel from './DrawerPanel';

const Drawer = ({ visible, transitionDuration, children }) => (
  <div className="Drawer">
    <DrawerContent visible={visible} transitionDuration={transitionDuration}>
      {children}
    </DrawerContent>
  </div>
);

Drawer.propTypes = {
  visible: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  transitionDuration: PropTypes.number,
};

Drawer.defaultProps = {
  transitionDuration: Theme.get('transition-duration'),
};

export { Drawer, DrawerPanel, DrawerHeader, DrawerBody, DrawerFooter };
export default Drawer;
